import Analytics from "analytics";
import segmentPlugin from "analytics-plugin-segment";

const logger = require("./utils/logger");

const analytics = Analytics({
  plugins: [
    segmentPlugin({
      writeKey: "26hbenLQCPBQM5ywfNxCglkDbZL19XUi",
      disableAnonymousTraffic: true,
    }),
  ],
});

analytics.on("page", ({ payload }) => {
  logger.debug("page", payload);
});

analytics.on("track", ({ payload }) => {
  logger.debug("track", payload);
});

// Set to global so analytics plugin will work
if (typeof window !== "undefined") {
  window.Analytics = analytics;
}

export default analytics;
